import React from 'react';

import {IMAGE_DIMENSIONS} from '../constants';
import type {BoneImageProps} from '../types';

import {Bone} from './Bone';

export const BoneImage: React.FC<BoneImageProps> = React.memo(
  ({variant, width, height, ...rest}) => {
    const dims = IMAGE_DIMENSIONS[variant];
    return (
      <Bone
        width={width ?? dims.width}
        height={height ?? dims.height}
        borderRadius={dims.borderRadius}
        {...rest}
      />
    );
  },
);
BoneImage.displayName = 'BoneImage';
